// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container1 {
  /*width: 500px;
  height: 300px;*/
  /* background-color: cyan;*/
  display: flex;
  justify-content: flex-end;
}

.item {
  width: 100px;
  height: 100px;
  background-color: green;
  display: inline-block;
  margin: 2px;
}

.activo-label {
  margin-left: 10px;
}

#amount.remove-padding {
  padding-right: 0px !important;
}

.cell-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
}

.thick-underline {
  text-decoration-thickness: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/Clientes/createClient.css"],"names":[],"mappings":"AAAA;EACE;iBACe;EACf,2BAA2B;EAC3B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".container1 {\n  /*width: 500px;\n  height: 300px;*/\n  /* background-color: cyan;*/\n  display: flex;\n  justify-content: flex-end;\n}\n\n.item {\n  width: 100px;\n  height: 100px;\n  background-color: green;\n  display: inline-block;\n  margin: 2px;\n}\n\n.activo-label {\n  margin-left: 10px;\n}\n\n#amount.remove-padding {\n  padding-right: 0px !important;\n}\n\n.cell-overflow {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  line-clamp: 1;\n}\n\n.thick-underline {\n  text-decoration-thickness: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
